exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-dept-tree-v3[data-v-7e7cd66e]{width:100%;height:100%;overflow:auto}.yxtbiz-dept-tree-v3-search[data-v-7e7cd66e]{height:80px}\n", ""]);

